import React from 'react';
import { ILuxuryHome } from '@share/common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faMapMarkerAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { isEmpty } from 'lodash';

import './style.scss';

interface IProps {
  home: ILuxuryHome;
}

export const LuxuryHomesDetailsHeader: React.FC<IProps> = ({ home }) => {
  
  const mainUnit = home?.units?.[0];
  const homeName = home?.title?.split(',')?.[0];

  return (  
    <header className="property-header">
      <div className="property-title">
        <h1>{homeName}</h1>
        <p>
          <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: '#8B6F40' }} /> {!isEmpty(home?.address) && <>{home?.address}, </>} {home?.city}, {home?.country}
        </p>
      </div>
      <div className="property-quick-info">
        <span><FontAwesomeIcon icon={faUser} style={{ color: '#1F4D5A' }} /> {mainUnit?.maxOccupancy} Guests</span>
        <span><FontAwesomeIcon icon={faBed} style={{ color: '#1F4D5A' }} /> {mainUnit?.bedroomsCount} Bedrooms</span>
      </div>
    </header>
  );
};
